var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashXmark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99951 4.25C7.99951 3.00736 9.00687 2 10.2495 2H13.7495C14.9922 2 15.9995 3.00736 15.9995 4.25V5H19.999C20.4132 5 20.749 5.33579 20.749 5.75C20.749 6.16421 20.4132 6.5 19.999 6.5H19.5V9.75H18V6.5H6V19.75C6 20.1642 6.33579 20.5 6.75 20.5H9.75V22H6.75C5.50736 22 4.5 20.9926 4.5 19.75V6.5H4C3.58579 6.5 3.25 6.16421 3.25 5.75C3.25 5.33579 3.58579 5 4 5H7.99951V4.25ZM9.49951 5H14.4995V4.25C14.4995 3.83579 14.1637 3.5 13.7495 3.5H10.2495C9.8353 3.5 9.49951 3.83579 9.49951 4.25V5Z",
    fill: "#323544"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4853 12.486C12.1924 12.7789 12.1924 13.2537 12.4853 13.5466L15.5637 16.625L12.4853 19.7034C12.1924 19.9963 12.1924 20.4711 12.4853 20.764C12.7782 21.0569 13.2531 21.0569 13.546 20.764L16.6243 17.6857L19.7026 20.7639C19.9955 21.0568 20.4704 21.0568 20.7633 20.7639C21.0562 20.4711 21.0562 19.9962 20.7633 19.7033L17.685 16.625L20.7633 13.5467C21.0562 13.2538 21.0562 12.7789 20.7633 12.4861C20.4704 12.1932 19.9955 12.1932 19.7026 12.4861L16.6243 15.5643L13.546 12.486C13.2531 12.1931 12.7782 12.1931 12.4853 12.486Z",
    fill: "#323544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashXmark);
export default __webpack_public_path__ + "static/media/trash-xmark.97f553266c644b15328fce4f67cee609.svg";
export { ForwardRef as ReactComponent };